import { helpers } from "../util/helpers.ts";
import i18n from "../util/i18n.ts";

export type LeagueDomainTarget = "data" | "history";

// N5-0b ①: the League tab root (Standings) hosts this domain hub row so the
// two browse-only league hubs — the Data hub (League leaders, whose
// DataDomainNav interlinks player stats / player ratings / team stats) and the
// History hub (season history / draft history / draft lottery) — regain a
// persistent, discoverable entry. The N5-0 audit found the four data pages
// orphaned (their only inbound was the self-referencing DataDomainNav ring after
// N3-C removed the standings shortcut card) and season history without a
// persistent league entry; this launcher row is the standings-side fix,
// mirroring HistoryDomainNav / DataDomainNav visually. Same-section links, so no
// cross-tab return seed is needed.
//
const TARGETS: {
  key: LeagueDomainTarget;
  href: string[];
  label: string;
  defaultLabel: string;
}[] = [
  {
    key: "data",
    href: ["leaders"],
    label: "leagueHub.navData",
    defaultLabel: "Data",
  },
  {
    key: "history",
    href: ["history"],
    label: "leagueHub.navHistory",
    defaultLabel: "History",
  },
];

export const LeagueDomainNav = () => (
  <nav
    aria-label={i18n.t("leagueHub.title", { ns: "ui", defaultValue: "League pages" })}
    className="league-domain-nav mb-3"
    data-league-domain-nav=""
  >
    <div className="d-flex flex-wrap gap-2" data-league-domain-links="">
      {TARGETS.map((target) => (
        <a
          className="btn btn-sm btn-light-bordered"
          data-league-domain-link={target.key}
          href={helpers.leagueUrl(target.href)}
          key={target.key}
        >
          {i18n.t(target.label, { ns: "ui", defaultValue: target.defaultLabel })}
        </a>
      ))}
    </div>
  </nav>
);

export default LeagueDomainNav;
